import type React from 'react';
import { twMerge } from 'tailwind-merge';


import { Stack } from 'ui/stack';

import Button from 'components/partials/button/button';

import MessageInfoItem from './message-info-item';

import {
  AI_ASSISTANT_CHAT_MESSAGE_MAX_WIDTH_CLASS,
  AI_ASSISTANT_CHAT_MESSAGE_MAX_WIDTH_PX,
} from '../../ai-assistant.constants';

import Icons from 'assets/icons';

interface MessageErrorItemProps {
  message: { content?: string };
  onRetry: () => void;
  isLimit?: boolean;
  isRetryDisabled?: boolean;
}

const MessageErrorItem = ({
  message,
  onRetry,
  isLimit = false,
  isRetryDisabled = false,
}: MessageErrorItemProps): React.JSX.Element => {
  if (isLimit) {
    return (
      <MessageInfoItem
        message={message.content ?? ''}
        className={twMerge('mb-5', AI_ASSISTANT_CHAT_MESSAGE_MAX_WIDTH_CLASS)}
      />
    );
  }

  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 1.5,
        width: 'fit-content',
        maxWidth: `${AI_ASSISTANT_CHAT_MESSAGE_MAX_WIDTH_PX}px`,
        bgcolor: 'tokens.critical.50',
        px: 2,
        py: 1.5,
        borderRadius: '0.375rem',
        borderWidth: '1px',
        borderColor: 'tokens.critical.600',
        mb: 2.5,
      }}
    >
      <p className="text-critical-800">{message.content}</p>

      <Button
        size="sm"
        variant="reserve-outlined"
        className="text-critical-600 bg-white border-critical-600 !h-7"
        iconBefore={<Icons.Retry />}
        onClick={onRetry}
        disabled={isRetryDisabled}
      >
        Retry
      </Button>
    </Stack>
  );
};

export default MessageErrorItem;
